import { useUserReducer } from "@/main/store/user";

import * as S from "./styles";
import { getTranslateByKey } from "@/main/services/utils";

interface IHeadProductList {
	showSupplierParts?: boolean;
	isOptionSelected?: boolean;
	showPrices?: boolean;
}

export default function HeadProductList({
	showSupplierParts = false,
	isOptionSelected = false,
	showPrices = true,
}: IHeadProductList) {
	const userReducer = useUserReducer();
	const titleColumnCart = isOptionSelected
		? getTranslateByKey("information.selectSupplier")
		: getTranslateByKey("quoteCard.addToCart");
	return (
		<>
			{!userReducer.userPreference.preferences.isViewCard && (
				<S.ProductsListHead>
					{showSupplierParts ? (
						<>
							<div className="products-list__column products-list__column--image">
								{getTranslateByKey("quoteCard.image")}
							</div>
							<div className="products-list__column products-list__column--supplier">
								{getTranslateByKey("companyType.supplier")}
							</div>
							<div className="products-list__column products-list__column--sku">
								{getTranslateByKey("quoteCard.sku")}
							</div>
							<div className="products-list__column products-list__column--partyType">
								{getTranslateByKey("information.partTypes")}
							</div>
							<div className="products-list__column products-list__column--product">
								{getTranslateByKey("quoteCard.product")}
							</div>
							<div className="products-list__column products-list__column--deliveryTime">
								{getTranslateByKey("information.deliveryDays")}
							</div>
							<div className="products-list__column products-list__column--rating">
								{getTranslateByKey("quoteCard.rating")}
							</div>
							{showPrices && (
								<div className="products-list__column products-list__column--price">
									{getTranslateByKey("information.price")}
								</div>
							)}
							<div className="products-list__column products-list__column--addToCart">{titleColumnCart}</div>
						</>
					) : (
						<>
							<div className="products-list__column products-list__column--partName">
								{getTranslateByKey("quoteCard.partName")}
							</div>
							<div className="products-list__column products-list__column--category">
								{getTranslateByKey("quoteCard.category")}
							</div>
							<div className="products-list__column products-list__column--subCategory">
								{getTranslateByKey("quoteCard.subCategory")}
							</div>
							<div className="products-list__column products-list__column--position">
								{getTranslateByKey("information.position")}
							</div>
							<div className="products-list__column products-list__column--addToCart">{titleColumnCart}</div>
						</>
					)}
				</S.ProductsListHead>
			)}
		</>
	);
}
